<template>
  <div
    style="height: 90%"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <el-card>
      <div class="bettew">
        <div style="display: flex; align-items: center">
          <!-- <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/appPage' }">APP首页</el-breadcrumb-item>
            <el-breadcrumb-item>APP编辑</el-breadcrumb-item>
          </el-breadcrumb> -->
          <el-select
            size="small"
            placeholder="请选择"
            @change="agentAppChange"
            v-model="values"
          >
            <el-option
              v-for="item in agentAppList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <!-- er -->
          <div style="margin-left: 40px">
            <el-select
              size="small"
              placeholder="请选择"
              @change="agentAppChange1"
              v-model="form.type"
            >
              <el-option
                v-for="item in AppList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>

        <el-button
          v-auth="'appEdit_/pageWidgetRelation/updatePageWidgetRelation'"
          type="primary"
          size="small"
          style="float: right"
          @click="updatePageWidgetRelation()"
          >保存</el-button
        >
      </div>
    </el-card>
    <div class="appEdit">
      <div class="toolbar">
        <div class="toolbar-s">
          <div
            class="bar-item"
            @click="
              operation = '轮播图';
              changeTab('add');
            "
          >
            <div
              style="font-size: 24px; padding: 2px 0"
              class="iconfont icon-lunbotu"
            ></div>
            <div style="font-size: 13px; padding: 2px 0">轮播图</div>
          </div>
          <div
            class="bar-item"
            @click="
              operation = '图文导航';
              changeTab('add');
            "
          >
            <div
              style="font-size: 24px; padding: 2px 0"
              class="iconfont icon-tuwendaohang"
            ></div>
            <div style="font-size: 13px; padding: 2px 0">图文导航</div>
          </div>
          <div
            class="bar-item"
            @click="
              operation = '商品课程';
              changeTab('add');
            "
          >
            <div
              style="font-size: 24px; padding: 2px 0"
              class="iconfont icon-shangpinkecheng"
            ></div>
            <div style="font-size: 13px; padding: 2px 0">商品课程</div>
          </div>
        </div>
      </div>
      <div class="app-view-top">
        <div class="app-view">
          <img src="../../../static/image/app.png" width="100%" height="auto" alt />
          <draggable
            v-model="appView.pageWidgetRelationDTOList"
            @update="datadragEnds"
            :options="{ animation: 500 }"
          >
            <div
              v-for="(element, indexTop) in appView.pageWidgetRelationDTOList"
              :key="indexTop"
            >
              <!-- :class="indexTop==0?'menuBg':''" -->
              <div
                v-if="element.type == 'lbt'"
                style="position: relative"
                :class="
                  indexNowSty == indexTop
                    ? indexTop == 0
                      ? 'menuBg line-dark'
                      : 'line-dark'
                    : indexTop == 0
                    ? 'menuBg line-dark-none1'
                    : 'line-dark-none1'
                "
              >
                <!-- :class="indexNowSty==indexTop?'line-dark':'line-dark-none1'" -->
                <div
                  @click="
                    indexNowSty = indexTop;
                    operation = '轮播图';
                    changeTab();
                  "
                  :style="element.list.length == 0 ? 'padding: 0px;' : 'padding: 10px;'"
                >
                  <el-carousel height="150px" v-if="element.list.length > 0">
                    <el-carousel-item v-for="(item, index) in element.list" :key="index">
                      <!-- <a :href="item.url"> -->
                      <img :src="item.img" width="100%" height="100%" alt />
                      <!-- </a> -->
                    </el-carousel-item>
                  </el-carousel>
                  <div
                    height="150px"
                    @click="
                      indexNowSty = indexTop;
                      operation = '轮播图';
                      changeTab();
                    "
                    v-else-if="element.list.length == 0"
                    class="view-none"
                  >
                    <div class="iconfont icon-lunbotu"></div>
                    <div>轮播图</div>
                  </div>
                </div>
                <i
                  slot="reference"
                  @click="deleteView(indexTop)"
                  title="删除轮播图"
                  class="el-icon-delete chunk-delete"
                ></i>
                <!-- <div class="chunk-showtext">轮播图</div> -->
              </div>
              <div
                class="showe-elete"
                v-if="element.type == 'twdh'"
                :class="indexNowSty == indexTop ? 'line-dark' : 'line-dark-none'"
              >
                <div
                  class="view-toolbar"
                  @click="
                    indexNowSty = indexTop;
                    operation = '图文导航';
                    changeTab();
                  "
                  v-if="element.list.length > 0"
                >
                  <div
                    class="view-toolbar-item"
                    :style="'width:' + 25 + '%'"
                    v-for="(item, index) in element.list"
                    :key="index"
                  >
                    <img
                      :src="item.img"
                      width="60px"
                      height="60px"
                      style="border-radius: 30px"
                      alt
                    />
                    <div class="toolbar-item-text">{{ item.title }}</div>
                  </div>
                </div>
                <div
                  height="150px"
                  v-else-if="element.list.length == 0 && element.type == 'twdh'"
                  @click="
                    indexNowSty = indexTop;
                    operation = '图文导航';
                    changeTab();
                  "
                  class="view-none"
                >
                  <div class="iconfont icon-tuwendaohang"></div>
                  <div>图文导航</div>
                </div>
                <i
                  slot="reference"
                  @click="deleteView(indexTop)"
                  title="删除图文导航"
                  class="el-icon-delete chunk-deletes"
                ></i>
                <!-- <div class="chunk-showtext">图文导航</div> -->
              </div>
              <div
                class="showe-elete"
                v-if="element.type == 'spkc'"
                :class="indexNowSty == indexTop ? 'line-dark' : 'line-dark-none'"
              >
                <div
                  class="view-operation"
                  @click="
                    indexNowSty = indexTop;
                    operation = '商品课程';
                    changeTab();
                  "
                  v-if="element.list.length > 0"
                >
                  <div class="view-operation-text">{{ element.name }}</div>
                  <div class="view-operation-list">
                    <!-- <a :href="item.url" v-for="(item,index) in element.list" :key="index"> -->
                    <img
                      :src="item.img"
                      width="170"
                      height="100px"
                      v-for="(item, index) in element.list"
                      :key="index"
                      alt
                    />
                    <!-- </a> -->
                  </div>
                </div>
                <div
                  height="150px"
                  v-else-if="element.list.length == 0"
                  @click="
                    indexNowSty = indexTop;
                    operation = '商品课程';
                    changeTab();
                  "
                  class="view-none"
                >
                  <div class="iconfont icon-shangpinkecheng"></div>
                  <div>商品课程</div>
                </div>
                <i
                  slot="reference"
                  @click="deleteView(indexTop)"
                  title="删除商品课程"
                  class="el-icon-delete chunk-deletes"
                ></i>
                <!-- <div class="chunk-showtext">商品课程</div> -->
              </div>
            </div>
          </draggable>
        </div>
      </div>
      <div class="operation">
        <div class="operation-name">
          {{
            appView.pageWidgetRelationDTOList[indexNowSty]
              ? appView.pageWidgetRelationDTOList[indexNowSty].name
              : ""
          }}
        </div>
        <div v-if="appView.pageWidgetRelationDTOList.length > 0">
          <div v-if="operation == '轮播图'">
            <div class="operation-1">
              <div class="operation-1-text">添加内容</div>
              <div class="operation-1-text1">
                最多添加12个轮播图，拖动选中的轮播图可对其排序，建议尺寸750*260像素
              </div>
            </div>
            <div class="operation-2">
              <draggable
                v-model="appView.pageWidgetRelationDTOList[indexNowSty].list"
                @update="datadragEnd"
                :options="{ animation: 500 }"
              >
                <!-- <transition-group> -->
                <div
                  class="operation-2-list"
                  v-for="(item, index) in appView.pageWidgetRelationDTOList[indexNowSty]
                    .list"
                  :key="index"
                >
                  <div class="list-img">
                    <el-upload
                      class="crm-upload"
                      :action="fileObj.url"
                      :before-upload="lbtbeforeUpload"
                      :on-success="lbtSuccessUpdate"
                      :headers="reqData"
                      :show-file-list="false"
                    >
                      <img
                        class="list-img"
                        :src="item.img"
                        @click="updateImg('lbt', index)"
                        alt
                      />
                      <div class="list-img-uptext" @click="updateImg('lbt', index)">
                        修改
                      </div>
                    </el-upload>
                  </div>
                  <div class="list-msg">
                    <div class="list-msg-item">
                      <span style="width: 50px">标题</span>
                      <el-input
                        size="mini"
                        style="width: 200px"
                        placeholder="选填"
                        v-model="item.title"
                        clearable
                      ></el-input>
                    </div>

                    <div class="list-msg-item">
                      <span style="width: 50px">链接</span>
                      <el-input
                        style="width: 140px"
                        @input="changeInput($event)"
                        size="mini"
                        v-if="item.urlType == 2 && item.goodsName != null"
                        v-model="item.goodsName"
                        clearable
                      ></el-input>
                      <el-input
                        style="width: 140px"
                        size="mini"
                        @input="changeInput($event)"
                        v-else-if="item.url != null"
                        v-model="item.url"
                        clearable
                      ></el-input>
                      <el-dropdown trigger="click" @command="handleCommand">
                        <span
                          class="el-dropdown-link"
                          style="
                            color: rgb(77, 148, 255);
                            cursor: pointer;
                            margin-left: 10px;
                          "
                        >
                          {{ item.url != null ? "修改" : "选择跳转到的页面" }}
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item :command="'lbt' + '-' + 1 + '-' + index"
                            >商品课程</el-dropdown-item
                          >
                          <!-- <el-dropdown-item :command="'lbt'+'-'+2+'-'+index">我的消息</el-dropdown-item> -->
                          <el-dropdown-item :command="'lbt' + '-' + 3 + '-' + index"
                            >自定义链接</el-dropdown-item
                          >
                          <el-dropdown-item :command="'lbt' + '-' + 4 + '-' + index"
                            >页面</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <!-- <div class="list-msg-item" style="margin-bottom: 0px;">
                      <el-checkbox v-model="item.imgShow">在苹果端小程序中隐藏</el-checkbox>
                      <el-popover
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        content="受相关政策影响,苹果端小程序内不允许出现“购买”相关信息,为保证您的小程序顺利审核通过,请隐藏带有此类信息的广告。"
                      >
                        <i
                          style="font-size: 14px;margin-left:6px;color:#999"
                          slot="reference"
                          class="el-icon-warning"
                        ></i>
                      </el-popover>
                    </div>-->
                  </div>
                  <i
                    class="el-icon-delete operation-delete"
                    title="删除"
                    @click="deleteItem('lbt', index)"
                  ></i>
                </div>
                <!-- </transition-group> -->
              </draggable>

              <div class="operation-2-button">
                <el-upload
                  class="crm-upload"
                  :action="fileObj.url"
                  :before-upload="lbtbeforeUpload"
                  :on-success="lbtSuccess"
                  :headers="reqData"
                  multiple
                  :show-file-list="false"
                >
                  <el-button icon="el-icon-plus" style="width: 338px"
                    >添加轮播图</el-button
                  >
                </el-upload>
              </div>
            </div>
          </div>
          <div v-if="operation == '图文导航'">
            <div class="line"></div>
            <div class="operation-1">
              <div class="operation-1-text">添加内容</div>
            </div>
            <div class="operation-2">
              <draggable
                v-model="appView.pageWidgetRelationDTOList[indexNowSty].list"
                @update="datadragEnd"
                :options="{ animation: 500 }"
              >
                <div
                  class="operation-2-list"
                  v-for="(item, index) in appView.pageWidgetRelationDTOList[indexNowSty]
                    .list"
                  :key="index"
                >
                  <div class="list-img">
                    <el-upload
                      class="crm-upload"
                      :action="fileObj.url"
                      :before-upload="lbtbeforeUpload"
                      :on-success="lbtSuccessUpdate"
                      :headers="reqData"
                      :show-file-list="false"
                    >
                      <img
                        class="list-img"
                        @click="updateImg('twdh', index)"
                        :src="item.img"
                        alt
                      />
                      <div class="list-img-uptext" @click="updateImg('twdh', index)">
                        修改
                      </div>
                    </el-upload>
                  </div>
                  <div class="list-msg">
                    <div class="list-msg-item">
                      <span style="width: 50px">标题</span>
                      <el-input
                        size="mini"
                        style="width: 200px"
                        @input="changeInput($event)"
                        placeholder="选填"
                        v-model="item.title"
                        clearable
                      ></el-input>
                    </div>

                    <div class="list-msg-item">
                      <span style="width: 50px">链接</span>
                      <el-input
                        style="width: 140px"
                        size="mini"
                        @input="changeInput($event)"
                        v-if="item.urlType == 2 && item.goodsName != null"
                        v-model="item.goodsName"
                        clearable
                      ></el-input>
                      <el-input
                        style="width: 140px"
                        size="mini"
                        @input="changeInput($event)"
                        v-else-if="item.url != null"
                        v-model="item.url"
                        clearable
                      ></el-input>
                      <el-dropdown trigger="click" @command="handleCommand">
                        <span
                          class="el-dropdown-link"
                          style="
                            color: rgb(77, 148, 255);
                            cursor: pointer;
                            margin-left: 10px;
                          "
                        >
                          {{ item.url != null ? "修改" : "选择跳转到的页面" }}
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item :command="'twdh' + '-' + 1 + '-' + index"
                            >商品课程</el-dropdown-item
                          >
                          <!-- <el-dropdown-item :command="'twdh'+'-'+2+'-'+index">我的消息</el-dropdown-item> -->
                          <el-dropdown-item :command="'twdh' + '-' + 3 + '-' + index"
                            >自定义链接</el-dropdown-item
                          >
                          <el-dropdown-item :command="'twdh' + '-' + 4 + '-' + index"
                            >页面</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <i
                    class="el-icon-delete operation-delete"
                    title="删除"
                    @click="deleteItem('twdh', index)"
                  ></i>
                </div>
                <!-- </transition-group> -->
              </draggable>

              <div class="operation-2-button">
                <el-upload
                  class="crm-upload"
                  :action="fileObj.url"
                  :before-upload="twdhbeforeUpload"
                  :on-success="twdhSuccess"
                  :headers="reqData"
                  multiple
                  :show-file-list="false"
                >
                  <el-button icon="el-icon-plus" style="width: 338px"
                    >添加图文导航</el-button
                  >
                </el-upload>
              </div>
            </div>
          </div>
          <div v-if="operation == '商品课程'">
            <!-- <div class="operation-1">
            <div class="operation-1-text">列表样式</div>
            <div class="operation-1-text1">
              <el-radio-group v-model="radio">
                <el-radio :label="3">小图</el-radio>
              </el-radio-group>
            </div>
            </div>-->
            <div class="line"></div>
            <div class="operation-1">
              <div class="operation-1-text">添加内容</div>
              <div class="label-show" style="margin-top: 20px">
                <span style="width: 50px">标题:</span>
                <el-input
                  size="mini"
                  style="width: 200px"
                  placeholder="选填"
                  v-if="appView.pageWidgetRelationDTOList[indexNowSty]"
                  v-model="appView.pageWidgetRelationDTOList[indexNowSty].name"
                  clearable
                ></el-input>
              </div>
              <div class="operation-1-text">课程来源</div>
              <div class="operation-1-text1">此页面最多添加50个，已添加3个</div>
            </div>
            <div class="operation-2">
              <div
                class="label-show chunk"
                v-for="(item, index) in appView.pageWidgetRelationDTOList[indexNowSty]
                  .list"
                :key="index"
              >
                <span style="width: 50px">课程:</span>
                <span style="color: #4d94ff; width: 260px">{{ item.title }}</span>
                <i
                  class="el-icon-delete chunk-delete"
                  title="删除"
                  @click="deleteItem('spkc', index)"
                ></i>
              </div>
              <div class="operation-2-button">
                <el-button icon="el-icon-plus" style="width: 338px" @click="spkcOpen()"
                  >添加课程</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="'添加商品'"
      :visible.sync="addFormVisible"
      width="60%"
      left
      :close-on-click-modal="false"
    >
      <el-form :label-width="formLabelWidth">
        <el-row :span="24">
          <el-col :sm="9" :md="9" :lg="9">
            <!-- <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-select v-model="chapterForm.pid" placeholder="请选择" clearable>
                <el-option v-for="item in pList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-cascader
                :show-all-levels="false"
                ref="tree"
                collapse-tags
                @change="subjectChange"
                :options="subjectTreeList"
                :props="subjectTreeProps"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="9" :md="9" :lg="9">
            <el-form-item label="商品名称">
              <el-input v-model="searchForm.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
            <el-button type="primary" @click="getList()">查询</el-button>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-table
              :data="tableList"
              tooltip-effect="dark"
              style="width: 100%"
              highlight-current-row
              @current-change="selectionChange"
              border
              v-loading="loading1"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
            >
              <el-table-column prop="name" show-overflow-tooltip label="商品">
                <template slot-scope="row">
                  <el-row>
                    <el-col :span="8">
                      <span>
                        <img
                          style="margin-right: 10px"
                          width="100%"
                          height="44px"
                          :src="
                            row.row.logo
                              ? row.row.logo
                              : '../../../static/image/noImg.png'
                          "
                        />
                      </span>
                    </el-col>
                    <el-col :span="16">
                      <span style="color: rgb(77, 148, 255); margin-left: 10px">{{
                        row.row.name
                      }}</span>
                      <span style="display: block; margin-left: 10px">
                        <span style="color: red">￥{{ row.row.price }}</span>
                        <span
                          style="text-decoration: line-through; color: rgb(162, 170, 188)"
                          >￥{{ row.row.originalPrice }}</span
                        >
                      </span>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="200"
                prop="agentPrice"
                label="售价"
              >
                <template slot-scope="row">
                  <span style="display: block">
                    <span style="color: red">￥{{ row.row.price }}</span>
                    <span style="text-decoration: line-through; color: rgb(162, 170, 188)"
                      >￥{{ row.row.originalPrice }}</span
                    >
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="validDay"
                width="100"
                label="有效期"
              >
                <template slot-scope="row">{{
                  row.row.validDay ? row.row.validDay + "天" : "不限"
                }}</template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="200"
                prop="subjectCourseName"
                label="所属科目"
              ></el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next"
              style="margin-top: 20px; text-align: right"
              :total="page.total"
              :page-size="page.pageSize"
              :current-page="page.pageNumber"
              @size-change="sizeChange"
              @current-change="currentChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="'添加商品'"
      :visible.sync="addFormVisibleSpkc"
      width="60%"
      left
      :close-on-click-modal="false"
    >
      <el-form :label-width="formLabelWidth">
        <el-row :span="24">
          <el-col :sm="9" :md="9" :lg="9">
            <!-- <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-select v-model="chapterForm.pid" placeholder="请选择" clearable>
                <el-option v-for="item in pList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-cascader
                :show-all-levels="false"
                ref="tree"
                collapse-tags
                @change="subjectChange"
                :options="subjectTreeList"
                :props="subjectTreeProps"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="9" :md="9" :lg="9">
            <el-form-item label="商品名称">
              <el-input v-model="searchForm.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
            <el-button type="primary" @click="getList()">查询</el-button>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-table
              :data="tableList"
              style="width: 100%"
              @selection-change="selectionChangeCpkc"
              border
              v-loading="loading1"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
            >
              <el-table-column
                show-overflow-tooltip
                type="selection"
                width="55"
              ></el-table-column>
              <el-table-column prop="name" show-overflow-tooltip label="商品">
                <template slot-scope="row">
                  <el-row>
                    <el-col :span="8">
                      <span>
                        <img
                          style="margin-right: 10px"
                          width="100%"
                          height="44px"
                          :src="
                            row.row.logo
                              ? row.row.logo
                              : '../../../static/image/noImg.png'
                          "
                        />
                      </span>
                    </el-col>
                    <el-col :span="16">
                      <span style="color: rgb(77, 148, 255); margin-left: 10px">{{
                        row.row.name
                      }}</span>
                      <span style="display: block; margin-left: 10px">
                        <span style="color: red">￥{{ row.row.price }}</span>
                        <span
                          style="text-decoration: line-through; color: rgb(162, 170, 188)"
                          >￥{{ row.row.originalPrice }}</span
                        >
                      </span>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="200"
                prop="agentPrice"
                label="售价"
              >
                <template slot-scope="row">
                  <span style="display: block">
                    <span style="color: red">￥{{ row.row.price }}</span>
                    <span style="text-decoration: line-through; color: rgb(162, 170, 188)"
                      >￥{{ row.row.originalPrice }}</span
                    >
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="validDay"
                width="100"
                label="有效期"
              >
                <template slot-scope="row">{{
                  row.row.validDay ? row.row.validDay + "天" : "不限"
                }}</template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="200"
                prop="subjectCourseName"
                label="所属科目"
              ></el-table-column>
            </el-table>

            <el-pagination
              background
              layout="total, prev, pager, next"
              style="margin-top: 20px; text-align: right"
              :total="page.total"
              :page-size="page.pageSize"
              :current-page="page.pageNumber"
              @size-change="sizeChange"
              @current-change="currentChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisibleSpkc = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="自定义链接" :visible.sync="addFormVisible3" width="40%" left>
      <el-form :label-width="formLabelWidth">
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="链接地址">
              <el-input style="width: 100%" v-model="imgUrl"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog3">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="页面" :visible.sync="addFormVisible4" width="40%" left>
      <el-form :label-width="formLabelWidth">
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="页面">
              <el-input style="width: 100%" v-model="pageUrl"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <div class="bettew">
          <div>
            <el-button type="primary" @click="pageUrl = 'course/mockExam.html'"
              >全真模拟</el-button
            >
            <el-button type="primary" @click="pageUrl = 'curriculum/index.html?free=1'"
              >免费课程</el-button
            >
          </div>
          <div>
            <el-button @click="addFormVisible4 = false">取 消</el-button>
            <el-button type="primary" @click="closeDialog4">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data() {
    return {
      form: {
        type: "",
      },
      radio: 1,
      newest: "热门课程",
      addEventSty: true,
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
      },
      searchForm: {
        sell: 1,
        name: "",
        subjectIds: [],
      },
      imgUrl: "http://",
      pageUrl: "",
      page: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      values: "",
      nowAppId: "",
      indexNow: null,
      indexNowSty: 0,
      indexType: null,
      indexSty: null,
      loading: false,
      loading1: false,
      addFormVisible: false,
      addFormVisible3: false,
      addFormVisible4: false,
      addFormVisibleSpkc: false,
      tableList: [],
      agentAppList: [],
      AppList: [
        {
          id: "1",
          name: "App",
        },
        {
          id: "2",
          name: "小程序",
        },
      ],
      subjectTreeList: [],
      appView: {
        pageWidgetRelationDTOList: [
          {
            name: "",
            type: "",
            list: [],
          },
        ],
      },
      checkList: {},
      subjectTreeProps: {
        value: "id",
        label: "name",
        multiple: true,
        children: "children",
      },
      formLabelWidth: "80px",
      operation: "轮播图",
      message: {
        imgList: [
          { img: "../../static/image/1.png", imgName: "", imgShow: 0 },
          { img: "../../static/image/1.png", imgName: "", imgShow: 0 },
        ],
      },
    };
  },
  created() {},
  methods: {
    deleteItem(sty, index) {
      this.appView.pageWidgetRelationDTOList[this.indexNowSty].list.splice(index, 1);
    },
    spkcOpen() {
      this.indexType = "spkc";
      this.indexSty = 1;
      this.openaddFormVisible();
    },
    changeInput() {
      this.$forceUpdate();
    },
    lbtSuccess(res, file, fileList, val) {
      this.appView.pageWidgetRelationDTOList[this.indexNowSty].list.push({
        img: res.data,
        title: "",
        urlType: 1,
        type: "lbt",
        url: null,
        goodsName: null,
        sort: this.appView.pageWidgetRelationDTOList[this.indexNowSty].list.length,
      });
      this.loading = false;
    },
    lbtbeforeUpload(file) {
      this.loading = true;
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        this.loading = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        this.loading = false;
      }
      return isJPG && isLt2M;
    },
    twdhSuccess(res, file, fileList, val) {
      this.appView.pageWidgetRelationDTOList[this.indexNowSty].list.push({
        img: res.data,
        title: "",
        urlType: 1,
        type: "twdh",
        url: null,
        goodsName: null,
        sort: this.appView.pageWidgetRelationDTOList[this.indexNowSty].list.length,
      });
      this.loading = false;
    },
    lbtSuccessUpdate(res, file, fileList, val) {
      console.log(
        this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[this.indexNow].img
      );
      this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[this.indexNow].img =
        res.data;
      this.indexType = null;
      this.indexNow = null;
      this.loading = false;
    },
    twdhbeforeUpload(file) {
      this.loading = true;
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        this.loading = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        this.loading = false;
      }
      return isJPG && isLt2M;
    },
    datadragEnds(evt) {
      evt.preventDefault();
    },
    datadragEnd(evt) {
      if (this.appView.pageWidgetRelationDTOList[this.indexNowSty].list)
        this.appView.pageWidgetRelationDTOList[this.indexNowSty].list.forEach(
          (item, index) => {
            item.sort = index;
          }
        );
      if (this.appView.pageWidgetRelationDTOList[this.indexNowSty].list)
        this.appView.pageWidgetRelationDTOList[this.indexNowSty].list.forEach(
          (item, index) => {
            item.sort = index;
          }
        );
      evt.preventDefault();
    },
    handleCommand(command) {
      console.log(command);
      let arr = command.split("-");
      let sty = arr[1];
      this.indexNow = arr[2];
      this.indexSty = arr[1];
      this.indexType = arr[0];
      if (sty == "1") {
        this.openaddFormVisible();
      } else if (sty == "3") {
        this.addFormVisible3 = true;
      } else if (sty == "4") {
        this.addFormVisible4 = true;
      }
    },
    selectionChange(val) {
      this.checkList = val;
    },
    selectionChangeCpkc(val) {
      this.checkList = val;
    },
    closeDialog() {
      this.addFormVisible = false;
      this.addFormVisibleSpkc = false;
      if (this.indexType == "lbt") {
        if (this.indexSty == 1) {
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].url = this.checkList.id;
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].goodsName = this.checkList.name;
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].urlType = 2;
        }
      } else if (this.indexType == "twdh") {
        if (this.indexSty == 1) {
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].url = this.checkList.id;
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].goodsName = this.checkList.name;
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].urlType = 2;
        }
      } else if (this.indexType == "spkc") {
        if (this.indexSty == 1) {
          if (this.checkList.length > 0)
            this.checkList.forEach((item) => {
              this.appView.pageWidgetRelationDTOList[this.indexNowSty].list.push({
                img: item.logo,
                title: item.name,
                urlType: 2,
                type: "spkc",
                url: item.id,
                sort: this.appView.pageWidgetRelationDTOList[this.indexNowSty].list
                  .length,
              });
            });
        }
      }

      this.checkList = {};
      this.indexSty = null;
      this.indexType = null;
      this.indexNow = null;
    },
    closeDialog3() {
      this.addFormVisible3 = false;
      if (this.indexType == "lbt") {
        if (this.indexSty == 3) {
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].url = this.imgUrl;
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].urlType = 1;
        }
      } else if (this.indexType == "twdh") {
        if (this.indexSty == 3) {
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].url = this.imgUrl;
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].urlType = 1;
        }
      }
      this.imgUrl = "http://";
      this.indexSty = null;
      this.indexType = null;
      this.indexNow = null;
    },
    closeDialog4() {
      this.addFormVisible4 = false;
      if (this.indexType == "lbt") {
        if (this.indexSty == 4) {
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].url = this.pageUrl;
          if (this.pageUr == "curriculum/index.html?free=1") {
            this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
              this.indexNow
            ].title = "免费课程";
          } else if (this.pageUr == "course/mockExam.html") {
            this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
              this.indexNow
            ].title = "全真模拟";
          }
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].urlType = 3;
        }
        console.log(
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[this.indexNow].url
        );
      } else if (this.indexType == "twdh") {
        if (this.indexSty == 4) {
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].url = this.pageUrl;
          if (this.pageUr == "curriculum/index.html?free=1") {
            this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
              this.indexNow
            ].title = "免费课程";
          } else if (this.pageUr == "course/mockExam.html") {
            this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
              this.indexNow
            ].title = "全真模拟";
          }
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list[
            this.indexNow
          ].urlType = 3;
        }
      }
      this.pageUrl = "";
      this.indexSty = null;
      this.indexType = null;
      this.indexNow = null;
    },
    subjectChange(val) {
      if (val) {
        this.searchForm.subjectIds = [];
        val.forEach((item) => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getList();
    },
    agentAppChange(val) {
      console.log(val);
      this.nowAppId = val;
      this.getPageWidgetRelationList();
    },
    agentAppChange1(val) {
      this.form.type = val;
      this.values = "";
      console.log(this.form.type);
      this.getAgentAppList();
    },
    openaddFormVisible() {
      if (this.indexType == "spkc") {
        this.addFormVisibleSpkc = true;
      } else {
        this.addFormVisible = true;
      }
      this.getList();
      this.api
        .getSubjectTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getList() {
      this.loading1 = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.api.goodsInfo
        .pageList(this.searchForm)
        .then((result) => {
          this.loading1 = false;
          this.tableList = result.data.records;
          this.page.total = result.data.total;
          this.arrsSelect = [];
        })

        .catch((error) => {
          console.log(error);
        });
    },
    getPageWidgetRelationList(agentAppId) {
      this.indexNowSty = 0;
      this.loading = true;
      this.api.pageWidgetRelation
        .getPageWidgetRelationList({ pageType: 1, agentAppId: this.nowAppId })
        .then((result) => {
          this.loading = false;
          if (result.success) {
            if (result.data == null) {
              this.appView = {
                pageWidgetRelationDTOList: [
                  {
                    name: "",
                    type: "",
                    list: [],
                  },
                ],
              };
            } else {
              this.appView = result.data;
            }
            console.log(this.appView);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAgentAppList() {
      this.api.agentApp
        .getAgentAppList(this.form)
        .then((result) => {
          this.loading = false;
          if (result.success) {
            console.log("123", result.data);
            this.agentAppList = result.data;
            if (result.data && result.data.length > 0) {
              console.log(result.data, 789789);
              this.values = result.data[0].name;
              this.nowAppId = result.data[0].id;
              this.getPageWidgetRelationList();
            } else {
              this.appView = {
                pageWidgetRelationDTOList: [
                  {
                    name: "",
                    type: "",
                    list: [],
                  },
                ],
              };
            }
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    updatePageWidgetRelation() {
      let array = [];
      let obj = this.appView;
      this.appView.pageWidgetRelationDTOList.forEach((itemsa, ins) => {
        if (itemsa.list.length > 0) {
          array.push(itemsa);
        } else {
          this.deleteView(ins);
          // this.appView.pageWidgetRelationDTOList.splice(ins, 1);
          // console.log(this.appView.pageWidgetRelationDTOList);
        }
      });
      // this.appView.pageWidgetRelationDTOList = array;
      if (this.addEventSty) {
        this.addEventSty = false;
        obj.agentAppId = this.nowAppId;
        this.api.pageWidgetRelation
          .updatePageWidgetRelation(obj)
          .then((result) => {
            this.addEventSty = true;
            if (result.success) {
              this.getPageWidgetRelationList();
              this.$message.success(result.message);
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    deleteView(index) {
      if (this.indexNowSty == index) {
        this.indexNowSty = 0;
      } else {
        if (this.indexNowSty != 0) this.indexNowSty--;
      }
      // this.operation = this.appView.pageWidgetRelationDTOList[this.indexNowSty].name;

      this.$nextTick(function () {
        this.appView.pageWidgetRelationDTOList.splice(index, 1);
      });
    },
    changeTab(val) {
      if (this.operation == "轮播图") {
        if (val == "add") {
          this.appView.pageWidgetRelationDTOList.push({
            type: "lbt",
            name: "轮播图",
            list: [],
          });
        }
      } else if (this.operation == "图文导航") {
        if (val == "add") {
          this.appView.pageWidgetRelationDTOList.push({
            type: "twdh",
            name: "图文导航",
            list: [],
          });
        }
      } else if (this.operation == "商品课程") {
        if (val == "add") {
          this.appView.pageWidgetRelationDTOList.push({
            type: "spkc",
            name: "商品课程",
            list: [],
          });
        }
      }
      if (val == "add") {
        this.indexNowSty = this.appView.pageWidgetRelationDTOList.length - 1;
      }
    },
    updateImg(sty, index) {
      this.indexNow = index;
      this.indexType = sty;
      console.log(sty, index);
    },
  },
  watch: {
    indexNowSty: function () {},
    operation: function (newVal) {
      if (this.operation == "轮播图") {
        if (this.appView.pageWidgetRelationDTOList[this.indexNowSty].list == null) {
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list = [];
        }
        console.log(this.appView.pageWidgetRelationDTOList.lbt);
      } else if (this.operation == "图文导航") {
        if (this.appView.pageWidgetRelationDTOList[this.indexNowSty].list == null) {
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list = [];
        }
      } else if (this.operation == "商品课程") {
        if (this.appView.pageWidgetRelationDTOList[this.indexNowSty].list == null) {
          this.appView.pageWidgetRelationDTOList[this.indexNowSty].list = [];
        }
      }
    },
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    },
  },
  mounted() {
    // this.getAgentAppList();
  },
};
</script>

<style lang="less" rel="stylesheet/less">
.bettew {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.showe-elete {
  position: relative;
  .chunk-showtext {
    position: absolute;
    right: -100px;
    top: 10px;
    background: #fff;
    font-size: 14px;
    color: #333;
    padding: 4px 10px;
  }
  .chunk-deletes {
    display: none;
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 20px;
    color: rgba(255, 85, 85, 1);
    font-weight: bold;
    cursor: pointer;
  }
}
.showe-elete:hover {
  .chunk-deletes {
    display: inline-block;
    z-index: 2000;
  }
}
.view-none {
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #999;
  background: #fff;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  .iconfont {
    font-size: 24px;
    color: #999;
  }
}
.box-card {
  .el-card__body {
    padding: 10px 20px !important;
  }
}
.appEdit {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  height: 100%;
  .chunk {
    height: 40px;
    line-height: 40px;
    padding: 0px 0px 0px 10px;
    background-color: rgba(255, 255, 255, 1);
    cursor: pointer;
    .chunk-delete {
      font-size: 14px;
      color: rgba(255, 85, 85, 1);
      display: none;
    }
  }
  .chunk:hover {
    .chunk-delete {
      display: inline-block;
    }
  }
  .label-show {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    span {
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .line {
    border-bottom: 1px solid rgba(238, 238, 238, 1);
  }
  .app-view-top::-webkit-scrollbar {
    // display: none;
  }
  .app-view-top {
    width: calc(100% - 570px);
    overflow-y: scroll;
    overflow-x: hidden;
    display: flex;
    height: calc(100% - 0px);
    justify-content: center;
    .app-view {
      margin-top: 20px;
      width: 375px;
      .view-operation {
        padding: 10px;
        .view-operation-text {
          font-size: 16px;
          color: #333;
          margin-bottom: 10px;
          font-weight: bold;
        }
        .view-operation-list {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          img {
            margin-bottom: 15px;
            border-radius: 10px;
          }
        }
        .chunk-delete {
          display: none;
          position: absolute;
          right: 10px;
          top: 10px;
          font-size: 20px;
          color: rgba(255, 85, 85, 1);
          font-weight: bold;
          cursor: pointer;
        }
      }
      .view-operation:hover {
        .chunk-delete {
          display: inline-block;
          z-index: 2000;
        }
      }
      .view-toolbar {
        display: flex;
        flex-wrap: wrap;
        .view-toolbar-item {
          padding: 10px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .view-toolbar-item-text {
            font-size: 14px;
            margin-top: 6px;
          }
        }
        .chunk-delete {
          display: none;
          position: absolute;
          right: 10px;
          top: 10px;
          font-size: 20px;
          color: rgba(255, 85, 85, 1);
          font-weight: bold;
          cursor: pointer;
        }
      }
      .view-toolbar:hover {
        .chunk-delete {
          display: inline-block;
          z-index: 2000;
        }
      }
      .menuBg {
        width: 100%;
        height: 170px;
        margin-top: -6px;
        /*background-color: #266ef6;*/
        background: -webkit-linear-gradient(#266ef6, #f1f5f8);
        /* Safari 5.1-6.0 */
        background: -o-linear-gradient(#266ef6, #f1f5f8);
        /* Opera 11.1-12.0 */
        background: -moz-linear-gradient(#266ef6, #f1f5f8);
        /* Firefox 3.6-15 */
        background: linear-gradient(#266ef6, #f1f5f8);
        /* 标准语法*/

        img {
          border-radius: 6px;
        }
        .chunk-delete {
          display: none;
          position: absolute;
          right: 10px;
          top: 10px;
          font-size: 20px;
          color: rgba(255, 85, 85, 1);
          font-weight: bold;
          cursor: pointer;
        }
        .chunk-showtext {
          position: absolute;
          right: -100px;
          top: 10px;
          z-index: 2000;
          background: #fff;
          font-size: 14px;
          color: #333;
          padding: 4px 10px;
        }
      }
      .menuBg:hover {
        .chunk-delete {
          display: inline-block;
          z-index: 2000;
        }
      }
    }
  }

  .line-dark {
    border: #266ef6 2px solid;
    box-sizing: border-box;
    .chunk-delete {
      display: none;
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 20px;
      color: rgba(255, 85, 85, 1);
      font-weight: bold;
      cursor: pointer;
    }
  }
  .line-dark-none {
    border: rgb(246, 249, 250) 2px solid;
    box-sizing: border-box;
  }
  .line-dark-none1 {
    // border: #266ef6 2px solid;
    box-sizing: border-box;
    .chunk-delete {
      display: none;
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 20px;
      color: rgba(255, 85, 85, 1);
      font-weight: bold;
      cursor: pointer;
    }
  }
  .line-dark:hover {
    .chunk-delete {
      display: inline-block;
      z-index: 2000;
    }
  }
  .line-dark-none1:hover {
    .chunk-delete {
      display: inline-block;
      z-index: 2000;
    }
  }
  .toolbar {
    width: 190px;
    // position: fixed;
    // top: 123px;
    // left: 220px;
    height: calc(100% - 0px);
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(238, 238, 238, 1);
    font-family: "微软雅黑";
    font-weight: 400;
    font-style: normal;
    .toolbar-s {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;

      .bar-item {
        width: 50%;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 80px;
        //   div {
        //     text-align: center;
        //   }
      }
      .bar-item:hover {
        background: #266ef6;
        color: #fff;
      }
    }
  }
  .operation {
    // position: fixed;
    // top: 123px;
    // right: 20px;
    width: 380px;
    height: calc(100% - 0px);
    // background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(238, 238, 238, 1);
    font-family: "微软雅黑";
    font-weight: 400;
    font-style: normal;
    .operation-2 {
      padding: 20px;
      .operation-2-button {
      }
      .operation-2-list:hover {
        .operation-delete {
          display: inline-block;
        }
      }
      .operation-2-list {
        position: relative;
        margin-bottom: 10px;
        background-color: rgba(255, 255, 255, 1);
        border-width: 1px;
        border-style: solid;
        padding: 10px;
        border-color: rgba(238, 238, 238, 1);
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        .operation-delete {
          position: absolute;
          bottom: 6px;
          right: 10px;
          z-index: 100;
          cursor: pointer;
          font-size: 14px;
          color: rgba(255, 85, 85, 1);
          display: none;
        }
        .list-msg {
          margin-left: 10px;
          .list-msg-item {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            span {
              font-size: 14px;
            }
          }
        }
        .list-img {
          width: 60px;
          height: 60px;
          z-index: 2000;
          position: relative;
          .list-img-uptext {
            z-index: 2000;
            width: 60px;
            height: 20px;
            position: absolute;
            bottom: 0;
            left: 0;
            background: #333;
            opacity: 0.6;
            color: #fff;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
          }
        }
      }
    }
    .operation-1 {
      background-color: rgba(255, 255, 255, 1);
      padding: 20px;
      .operation-1-text {
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 14px;
        color: #455a64;
        line-height: 14px;
      }
      .operation-1-text1 {
        padding-top: 10px;
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        color: #a2aabc;
        line-height: 16px;
      }
    }
    .operation-name {
      background-color: rgba(255, 255, 255, 1);
      width: 100%;
      height: 60px;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(238, 238, 238, 1);
      font-weight: 700;
      font-style: normal;
      font-size: 16px;
      color: #455a64;
      text-align: left;
      line-height: 60px;
      padding: 0 0 0 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/appPage/appEdit copy 2.vue